import React from 'react';

export const ProductOverview: React.FC = () => {
  return (
    <section id="products" className="products">
      <div className="container">
        <h2 className="section-title">製品情報</h2>
        <div className="product-overview">
          <div className="product-image">
            <img src="/org/pickup/wall_image.jpg" alt="WiCanvas" />
          </div>
          <div className="product-details">
            <h3>オールインワン・デジタルサイネージ</h3>
            <p>
              WiCanvasは、ディスプレイ・メディアプレーヤー・ソフトウェアを一体化した革新的なデジタルサイネージソリューションです。シンプルで美しいデザインと高い機能性を両立しています。
            </p>
            <ul className="product-specs">
              <li>
                <strong>薄型デザイン</strong>:約13mm〜30mmの超薄型フレーム
              </li>
              <li><strong>高解像度</strong>:Full HD / 4K対応</li>
              <li><strong>Wi-Fi 6対応</strong>:安定したワイヤレス通信</li>
              <li><strong>クラウド管理</strong>:専用CMSで遠隔一括管理</li>
              <li><strong>多様なサイズ</strong>:19インチ〜75インチまで対応</li>
              <li><strong>屋外対応</strong>:IP56防水・防塵、最大2500nits</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
